import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Modal, Switch, Stack, SimpleGrid, TextInput, Textarea, PasswordInput, Center, Box, Progress, Badge, NumberInput, PinInput, Checkbox } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin,
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { Admin_Bank_Add, Admin_Bank_Delete, Admin_Banks_get, Get_All_Users, Get_Individual_user_wallet_details, Master_Dist_Signup, Update_Master_dist_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";
import { IconCheck, IconX } from "@tabler/icons-react";
const { Search } = Input;










const AdminBanks = ({ Headername }) => {

    const columns = [
        {
            title: "S.No.",
            width: 60,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Bank Name",
            dataIndex: "BankName",
            width: 120,
            render: (code) => <Text copyable>{code}</Text>,
        },
        {
            title: "Bank IFSC",
            dataIndex: "BankIfsc",
            width: 180,
        },
        {
            title: "Bank Holder Name",
            dataIndex: "BankHolder",
            width: 220,
        },
        {
            title: "Account Number",
            dataIndex: "BankAccountNumber",
            width: 120,
            // render: (type) => (
            //     <Tag color={type === "Retailer" ? "blue" : "purple"}>
            //         {type}
            //     </Tag>
            // ),
        },
        {
            title: "Bank Branch",
            dataIndex: "BankBranch",
            width: 130,
           // render: (mobile) => <Text copyable>{mobile}</Text>,
        },
        {
            title: "Created On",
            dataIndex: "createdAt",
            width: 170,
            render: (date) => dayjs(date).format("DD MMM YYYY"),
        },
        {
            title: "Action",
            width: 110,
            fixed: "right",
            render: (_, record) => (
                <Button
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setSelectedbank(record);
                        setDeleteModal(true);
                    }}
                >
                    Delete
                </Button>
            ),
        },
    ];
    const { user } = Userauthcontexthooks();
    const [createBank, setCreateBank] = useState({
        BankName: "",
        BankIfsc: "",
        BankHolder: "",
        BankAccountNumber: "",
        BankBranch: "",
    });
    const [createModal, setCreateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [fetchbanksLoading, setFetchbanksLoading] = useState(true);
    const [Bankslists, setbankslists] = useState([]);
    const [Filteredbankslists, setFilteredbankslists] = useState([]);
    const [searchbanks, setsearchbanks] = useState('');
    const [selectedbank, setSelectedbank] = useState(null);
    const [deleteloading, setDeleteloading] = useState(false);

    const handleInput = (e) => {
        const { name, value } = e.target;

        setCreateBank((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        let filtered = [...Bankslists];



        // Search Filter
        if (searchbanks.trim()) {
            const keyword = searchbanks.toLowerCase().trim();

            filtered = filtered.filter((item) =>
                item.BankName?.toLowerCase().includes(keyword) ||
                item.BankIfsc?.toLowerCase().includes(keyword) ||
                String(item.BankAccountNumber).includes(keyword)
            );
        }

        setFilteredbankslists(filtered);
    };

    const handleReset = () => {
        setsearchbanks("");
        setFilteredbankslists(Bankslists);
    };

    const fetchAdminBanks = async () => {
        try {
            setFetchbanksLoading(true);
            const data = await Admin_Banks_get();
            if (data.success) {
                //console.log(data);
                setbankslists(data?.AdminBanks);
                setFilteredbankslists(data?.AdminBanks);
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setFetchbanksLoading(false);
        }
    }

    const CreateBank = async () => {
        const { BankName, BankIfsc, BankHolder, BankAccountNumber, BankBranch } = createBank;
        if (!BankName || !BankIfsc || !BankHolder || !BankAccountNumber || !BankBranch) {
            message.error('All fields are required');
            return;
        }

        const body = {
            BankName: BankName.toLocaleUpperCase(),
            BankIfsc: BankIfsc.toLocaleUpperCase(),
            BankHolder: BankHolder.toLocaleUpperCase(),
            BankAccountNumber,
            BankBranch
        }
        try {
            setSubmitLoading(true);
            const data = await Admin_Bank_Add(body);
            if (data.success) {
                //console.log(data);
                message.success(data?.message);
                setCreateBank({
                    BankName: "",
                    BankIfsc: "",
                    BankHolder: "",
                    BankAccountNumber: "",
                    BankBranch: "",
                })
                setCreateModal(false);
                fetchAdminBanks();
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setSubmitLoading(false);
        }

    }

    const DeleteBank = async () => {

        if (!selectedbank) {
            message.error('Please select bank');
            return;
        }
        try {
            setDeleteloading(true);
            const data = await Admin_Bank_Delete(selectedbank._id);
            if (data.success) {
                //console.log(data);
                message.success(data?.message);
                setDeleteModal(false);
                setSelectedbank(null);
                fetchAdminBanks();
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setDeleteloading(false);
        }
    }

    useEffect(() => {
        const fetchAdminBanks = async () => {
            try {
                const data = await Admin_Banks_get();
                if (data.success) {
                    //console.log(data);
                    setbankslists(data?.AdminBanks);
                    setFilteredbankslists(data?.AdminBanks);
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setFetchbanksLoading(false);
            }
        }

        if (user) {
            fetchAdminBanks();
        }

    }, [user])

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Admin Banks</Title>
                <Text size="xs">Manage company banks for top in requests</Text>
            </Container>
            <Group justify="flex-end" mt="sm" mr={'md'}>
                <Button
                    variant="light"
                    onClick={() => setCreateModal(true)}

                >
                    Create Banks
                </Button>
            </Group>
            <Container size={'lg'} mt={'lg'}>
                <Card title="Listed banks" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search by Name / IFSC / A/C No"
                                allowClear
                                value={searchbanks}
                                onChange={(e) => setsearchbanks(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                                <Button type="secondary" variant="outline" onClick={fetchAdminBanks}>
                                    Refresh
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={Filteredbankslists}
                            loading={fetchbanksLoading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        />
                    </div>

                </Card>
            </Container>



            <Modal
                opened={createModal}
                onClose={() => setCreateModal(false)}
                title="Create Banks"
                size="xl"
                centered
            >
                <SimpleGrid cols={2} spacing="md">

                    <TextInput
                        label="Bank Name"
                        name="BankName"
                        value={createBank.BankName}
                        onChange={handleInput}
                        required
                    />

                    <TextInput
                        label="Bank IFSC"
                        name="BankIfsc"
                        value={createBank.BankIfsc}
                        onChange={handleInput}
                        maxLength={11}
                        required
                    />

                    <TextInput
                        label="Bank Holder Name"
                        name="BankHolder"
                        value={createBank.BankHolder}
                        onChange={handleInput}
                        required
                    />
                    <TextInput
                        label="Bank Account Number"
                        name="BankAccountNumber"
                        value={createBank.BankAccountNumber}
                        onChange={handleInput}
                        maxLength={18}
                        required
                    />

                    <TextInput
                        label="Bank Branch"
                        name="BankBranch"
                        value={createBank.BankBranch}
                        onChange={handleInput}
                        required
                    />

                </SimpleGrid>

                <Group justify="flex-end" mt="xl">

                    <Button
                        variant="default"
                        onClick={() => setCreateModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        loading={submitLoading}
                        onClick={CreateBank}
                    >
                        Create Bank
                    </Button>

                </Group>
            </Modal>
            <Modal
                opened={deleteModal}
                onClose={() => setDeleteModal(false)}
                title="Delete Banks"
                size="xl"
                centered
            >
                <SimpleGrid cols={2} spacing="md">

                    <TextInput
                        label="Bank Name"
                        name="BankName"
                        value={selectedbank?.BankName}
                        readOnly
                    />

                    <TextInput
                        label="Bank IFSC"
                        name="BankIfsc"
                        value={selectedbank?.BankIfsc}
                        readOnly
                    />

                    <TextInput
                        label="Bank Holder Name"
                        name="BankHolder"
                        value={selectedbank?.BankHolder}
                        readOnly
                    />
                    <TextInput
                        label="Bank Account Number"
                        name="BankAccountNumber"
                        value={selectedbank?.BankAccountNumber}
                        readOnly
                    />

                    <TextInput
                        label="Bank Branch"
                        name="BankBranch"
                        value={selectedbank?.BankBranch}
                        readOnly
                    />

                </SimpleGrid>

                <Group justify="flex-end" mt="xl">

                    <Button
                        variant="default"
                        onClick={() => setDeleteModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        loading={deleteloading}
                        onClick={DeleteBank}
                    >
                        Confirm Delete
                    </Button>

                </Group>
            </Modal>
        </>
    )
}

export default AdminBanks;